import React from "react";

export default function Services() {
  return (
    <div className="text-center">
      <h1 className="text-3xl border-b-2 border-gray-500 font-semibold inline-block py-2 px-5 mt-5 text-center">
        Services
      </h1>
      <div className="h-96 flex justify-center items-center text-7xl font-extrabold text-gray-300">
        <h3>Coming Soon...</h3>
      </div>
    </div>
  );
}
